// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Emotion from "../../bindings/Emotion.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

let baseStyles = Emotion.Css.css({
  width: "100%",
  fontFamily: "inherit",
  fontSize: "inherit",
  border: "none",
  outline: "none",
  transition: Emotion.Utils.Animate.getDuration("fast") + " ease-out",
  position: "relative",
  backgroundColor: "transparent"
});

function getSizeStyles(size) {
  if (size === "md") {
    return Emotion.Css.css({
      height: "2.5rem",
      padding: "0.625rem 0.75rem",
      fontSize: "1rem"
    });
  } else if (size === "sm") {
    return Emotion.Css.css({
      height: "2rem",
      padding: "0.5rem 0.75rem",
      fontSize: "0.875rem"
    });
  } else {
    return Emotion.Css.css({
      height: "3rem",
      padding: "0.75rem 1rem",
      fontSize: "1.125rem"
    });
  }
}

function getVariantStyles(variant) {
  if (variant === "filled") {
    return Emotion.Css.css({
      backgroundColor: Emotion.Utils.Color.bgElevated,
      border: "1px solid transparent",
      borderRadius: Emotion.Utils.Border.getRadius("md"),
      color: Emotion.Utils.Color.textPrimary,
      ":hover": {
        backgroundColor: Emotion.Utils.Color.border
      },
      ":focus": {
        backgroundColor: Emotion.Utils.Color.bgSecondary,
        borderColor: Emotion.Utils.Color.primary,
        boxShadow: Emotion.Utils.Shadow.getFocusShadow("primary")
      }
    });
  } else if (variant === "default") {
    return Emotion.Css.css({
      backgroundColor: Emotion.Utils.Color.bgSecondary,
      border: `1px solid ` + Emotion.Utils.Color.border,
      borderRadius: Emotion.Utils.Border.getRadius("md"),
      color: Emotion.Utils.Color.textPrimary,
      ":focus": {
        borderColor: Emotion.Utils.Color.primary,
        boxShadow: Emotion.Utils.Shadow.getFocusShadow("primary")
      }
    });
  } else if (variant === "outlined") {
    return Emotion.Css.css({
      backgroundColor: "transparent",
      border: `2px solid ` + Emotion.Utils.Color.border,
      borderRadius: Emotion.Utils.Border.getRadius("md"),
      color: Emotion.Utils.Color.textPrimary,
      ":focus": {
        borderColor: Emotion.Utils.Color.primary,
        boxShadow: Emotion.Utils.Shadow.getFocusShadow("primary")
      }
    });
  } else if (variant === "editorial") {
    return Emotion.Css.css({
      height: "auto",
      backgroundColor: "transparent",
      border: "none",
      borderRadius: Emotion.Utils.Border.getRadius("sm"),
      padding: "0.2rem",
      marginInline: "-0.2rem",
      color: Emotion.Utils.Color.textPrimary,
      ":focus": {
        backgroundColor: Emotion.Utils.Color.bgSecondary
      }
    });
  } else {
    return Emotion.Css.css({
      backgroundColor: "transparent",
      border: "none",
      borderBottom: `2px solid ` + Emotion.Utils.Color.border,
      borderRadius: "0",
      color: Emotion.Utils.Color.textPrimary,
      padding: "0.5rem 0",
      ":focus": {
        borderBottomColor: Emotion.Utils.Color.primary,
        boxShadow: `0 1px 0 0 ` + Emotion.Utils.Color.primary
      }
    });
  }
}

function getStateStyles(state) {
  if (state === "warning") {
    return Emotion.Css.css({
      borderColor: Emotion.Utils.Color.warning,
      color: Emotion.Utils.Color.warning
    });
  } else if (state === "default") {
    return "";
  } else if (state === "success") {
    return Emotion.Css.css({
      borderColor: Emotion.Utils.Color.success,
      color: Emotion.Utils.Color.success
    });
  } else {
    return Emotion.Css.css({
      borderColor: Emotion.Utils.Color.error,
      color: Emotion.Utils.Color.error
    });
  }
}

function getDisabledStyles() {
  return Emotion.Css.css({
    opacity: "0.5",
    cursor: "not-allowed",
    pointerEvents: "none"
  });
}

function getReadOnlyStyles() {
  return Emotion.Css.css({
    backgroundColor: Emotion.Utils.Color.bgPrimary,
    cursor: "default"
  });
}

function getPlaceholderStyles() {
  return Emotion.Css.css({
    "::placeholder": {
      color: Emotion.Utils.Color.placeholder,
      opacity: "1"
    }
  });
}

function Input$Input(props) {
  let __required = props.required;
  let __autoFocus = props.autoFocus;
  let __type_ = props.type_;
  let __className = props.className;
  let __readOnly = props.readOnly;
  let __disabled = props.disabled;
  let __state = props.state;
  let __size = props.size;
  let __variant = props.variant;
  let variant = __variant !== undefined ? __variant : "default";
  let size = __size !== undefined ? __size : "md";
  let state = __state !== undefined ? __state : "default";
  let disabled = __disabled !== undefined ? __disabled : false;
  let readOnly = __readOnly !== undefined ? __readOnly : false;
  let className = __className !== undefined ? __className : "";
  let type_ = __type_ !== undefined ? __type_ : "text";
  let autoFocus = __autoFocus !== undefined ? __autoFocus : false;
  let required = __required !== undefined ? __required : false;
  let inputClassName = Emotion.Css.cx([
    baseStyles,
    variant === "editorial" ? "" : getSizeStyles(size),
    getVariantStyles(variant),
    getStateStyles(state),
    getPlaceholderStyles(),
    disabled ? getDisabledStyles() : "",
    readOnly ? getReadOnlyStyles() : "",
    className
  ]);
  let typeStr = type_ === "text" ? "text" : (
      type_ === "search" ? "search" : (
          type_ === "email" ? "email" : (
              type_ === "tel" ? "tel" : (
                  type_ === "url" ? "url" : (
                      type_ === "number" ? "number" : "password"
                    )
                )
            )
        )
    );
  return JsxRuntime.jsx("input", {
    "aria-label": props.ariaLabel,
    "aria-describedby": props.ariaDescribedby,
    defaultValue: props.defaultValue,
    className: inputClassName,
    id: props.id,
    autoComplete: props.autoComplete,
    autoFocus: autoFocus,
    disabled: disabled,
    maxLength: props.maxLength,
    minLength: props.minLength,
    name: props.name,
    pattern: props.pattern,
    placeholder: props.placeholder,
    readOnly: readOnly,
    required: required,
    type: typeStr,
    value: props.value,
    onFocus: props.onFocus,
    onBlur: props.onBlur,
    onChange: props.onChange
  });
}

let Input = {
  baseStyles: baseStyles,
  getSizeStyles: getSizeStyles,
  getVariantStyles: getVariantStyles,
  getStateStyles: getStateStyles,
  getDisabledStyles: getDisabledStyles,
  getReadOnlyStyles: getReadOnlyStyles,
  getPlaceholderStyles: getPlaceholderStyles,
  make: Input$Input
};

export {
  Input,
}
/* baseStyles Not a pure module */
